class CartBundleList extends HTMLElement {
    constructor() {
        super();
        this.isListVisible = true;
    }

    connectedCallback() {
        this.button = this.querySelector('.bundle-button');
        this.list = this.querySelector('ul');

        this.button.addEventListener('click', this.toggleListVisibility.bind(this));
    }

    disconnectedCallback() {
        this.button.removeEventListener('click', this.toggleListVisibility.bind(this));
    }

    toggleListVisibility() {
        this.isListVisible = !this.isListVisible;
        this.setAttribute('data-state', this.isListVisible ? 'expanded' : 'hidden');
    }
}

customElements.define('cart-bundle-list', CartBundleList);